import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function GlobalBanking(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, "data-tidal": "TidalIllustration", "data-tidal-illustration": "GlobalBanking", sx, viewBox, children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M44.175 23.175c0 2.625-.6 5.1-1.725 7.275-2.7 5.325-8.175 9-14.55 9-9 0-16.275-7.275-16.275-16.275 0-1.5.225-2.925.6-4.275C13.65 13.8 17.4 9.67502 22.35 7.87502c1.2-.45 2.475-.75 3.825-.9.6-.075 1.2-.075 1.8-.075 4.425 0 8.475 1.8 11.4 4.64998.975.975 1.875 2.1 2.55 3.3 1.425 2.4 2.25 5.25 2.25 8.325Z",
        fill: theme.vars.palette.secondary.main
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M22.8 13.725c-.15.6-.3 1.2-.6 1.8-.3.525-.825.975-1.05 1.575-.3.75-.15 1.65 0 2.4.075.45.15.975.075 1.425-.075.45-.3.975-.675 1.2-.3.225-.675.3-.9.6-.45.525-.075 1.275.225 1.875.375.6.675 1.35.3 1.875l-.225.225h-.375c-.75-.225-1.425-.675-2.025-1.125-.3-.225-.675-.45-.975-.675-.6-.375-1.2-.825-1.425-1.5-.15-.375-.225-.825-.3-1.275-.3-.975-1.125-1.65-1.8-2.325-.225-.225-.525-.525-.75-.9 1.425-5.1 5.175-9.22498 10.125-11.02498.225.45.525.975.675 1.425.225 1.42498 0 2.92498-.3 4.42498Zm.075 11.1c.375-.525 1.05-.75 1.725-.9.675-.15 1.275-.15 1.875-.45.375-.15.75-.45 1.125-.45.45-.075.9.15 1.35.375 1.125.675 1.95 1.8 2.175 3.075.225.9.15 1.8.375 2.7.225.825.825 1.65 1.5 2.175.225.15.525.3.675.525.225.3.3.675.3.975.075.3.075.675.15.975.075.3.075.525 0 .825-.075.6-.675 1.125-1.275 1.275-.6.15-1.275.15-1.95 0-.75-.15-1.5-.375-2.025-.9-.75-.825-.75-2.175-1.425-3.075-.825-1.05-2.25-1.275-3.525-1.725-.375-.15-.825-.375-1.05-.675-.45-.525-.675-1.275-.675-2.025.15-.825.225-2.025.675-2.7ZM39.3 11.55c-.3.45-.675.825-1.05 1.2-.675.675-1.575 1.275-2.475 1.5-.825.15-1.65.15-2.475.3-.675.15-1.275.45-1.875.675-.6.225-1.35.375-1.95.075-.6-.225-.975-.75-1.2-1.35-.225-.6-.15-1.2 0-1.8.075-.3.15-.675 0-.975-.075-.15-.225-.225-.375-.3-.825-.525-1.35-1.42498-1.575-2.39998-.15-.45-.075-.975-.15-1.5.6-.075 1.2-.075 1.8-.075 4.35-.075 8.4 1.725 11.325 4.64998Zm4.875 11.625c0 2.625-.6 5.1-1.725 7.275-.525-.075-1.05-.225-1.5-.45-.225-.075-.45-.225-.675-.375-.675-.525-.9-1.425-1.425-2.1-.525-.6-1.275-.9-1.95-1.275-.675-.45-1.2-1.125-1.425-1.875-.15-.75.075-1.65.75-2.1.375-.225.9-.375 1.125-.75.075-.15.15-.3.225-.375.3-.525 1.05-.675 1.65-.825.675-.15 1.35-.45 1.5-1.05.15-.6-.3-1.2-.375-1.8 0-.675.45-1.2.825-1.725.225-.225.45-.525.675-.75 1.5 2.25 2.325 5.1 2.325 8.175Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx("path", { d: "m14.25 21.75-10.5 3v3h21v-3l-10.5-3Z", fill: theme.vars.palette.primary.dark }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M23.25 27.75V39H21v-6c0-.375-.15-.75-.45-1.05-.3-.3-.675-.45-1.05-.45-.825 0-1.5.675-1.5 1.5v6h-2.25v-6c0-.375-.15-.75-.45-1.05-.3-.3-.675-.45-1.05-.45-.825 0-1.5.675-1.5 1.5v6H10.5v-6c0-.375-.15-.75-.45-1.05-.3-.3-.675-.45-1.05-.45-.825 0-1.5.675-1.5 1.5v6H5.25V27.75h18Z",
        fill: theme.vars.palette.secondary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M24 42H4.5c-.45 0-.75-.3-.75-.75v-1.5c0-.45.3-.75.75-.75H24c.45 0 .75.3.75.75v1.5c0 .45-.3.75-.75.75Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M21 33v6h-3v-6c0-.825.675-1.5 1.5-1.5.375 0 .75.15 1.05.45.3.3.45.675.45 1.05Zm-5.25 0v6h-3v-6c0-.825.675-1.5 1.5-1.5.375 0 .75.15 1.05.45.3.3.45.675.45 1.05Zm-5.25 0v6h-3v-6c0-.825.675-1.5 1.5-1.5.375 0 .75.15 1.05.45.3.3.45.675.45 1.05Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx("path", { d: "M23.25 27.75h-18v1.5h18v-1.5Z", fill: theme.vars.palette.secondary.main })
  ] });
}
GlobalBanking.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "GlobalBanking"
};
validateTidalLicense();
export {
  GlobalBanking
};
//# sourceMappingURL=GlobalBanking.js.map
